import { isEqual } from 'lodash'

import React from 'react'
import { useDispatch } from 'hooks/use-redux'
import InternalTeamShareForm from 'components/share-channels/internal-team-share-form'
import type { ChannelShareFormProps } from '../../types'

const MyTeamTab = (props: ChannelShareFormProps): React.ReactNode => {
  const { group, parentGroup, updateGroup } = props
  const dispatch = useDispatch()

  const handleSubmit = (error, data) => {
    if (error || !data) return
    const { members, managers } = data

    if (group.id) {
      const updateData = {
        id: group.id,
        hidden: group.hidden,
        name: group.name,
        internal_name: group.internal_name.length
          ? group.internal_name
          : group.name,
        parent: parentGroup ? parentGroup.id : null,
        bulk_upload: group.bulk_upload,
        members,
        managers,
      }
      dispatch(updateGroup(updateData))
    }
  }

  // @ts-expect-error
  return <InternalTeamShareForm {...props} onSubmit={handleSubmit} />
}

export default MyTeamTab
